import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { useStats } from 'react-instantsearch';
import { DEFAULT_TEXT, getDefaultText } from '../../config/constants';
const SearchStats = props => {
  const {
    t
  } = useTranslation();

  // nbHits is total number of hits found
  const {
    nbHits
  } = useStats();
  const {
    translation,
    className,
    hiddenWhenEmpty
  } = props;
  const classNames = c('Searchkit__Stats', className);
  if (!nbHits && hiddenWhenEmpty) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classNames,
    "aria-live": "polite"
  }, translation ? translation(nbHits) : t(['searchkit.stats.total_results', getDefaultText(DEFAULT_TEXT.STATS.TOTAL_RESULTS, 'count', (nbHits === null || nbHits === void 0 ? void 0 : nbHits.toString()) || '0')], {
    count: nbHits
  }));
};
export default SearchStats;